import { h } from 'vue'
import * as RemixIcons from '@remixicon/vue'

const aliases = {
  collapse: 'ri-arrow-up-s-line',
  complete: 'ri-check-line',
  cancel: 'ri-close-line',
  close: 'ri-close-line',
  delete: 'ri-close-circle-line',
  clear: 'ri-close-line',
  success: 'ri-checkbox-circle-line',
  info: 'ri-information-line',
  warning: 'ri-alert-line',
  error: 'ri-close-circle-line',
  prev: 'ri-arrow-left-s-line',
  next: 'ri-arrow-right-s-line',
  checkboxOn: 'ri-checkbox-fill',
  checkboxOff: 'ri-checkbox-blank-line',
  checkboxIndeterminate: 'ri-checkbox-indeterminate-line',
  delimiter: 'ri-checkbox-blank-circle-line',
  sort: 'ri-arrow-up-line',
  expand: 'ri-arrow-down-s-line',
  menu: 'ri-menu-line',
  subgroup: 'ri-arrow-down-s-line',
  dropdown: 'ri-arrow-down-s-line',
  radioOn: 'ri-radio-button-line',
  radioOff: 'ri-checkbox-blank-circle-line',
  edit: 'ri-pencil-line',
  ratingEmpty: 'ri-star-line',
  ratingFull: 'ri-star-fill',
  ratingHalf: 'ri-star-half-line',
  loading: 'ri-loader-4-line',
  first: 'ri-skip-back-line',
  last: 'ri-skip-forward-line',
  unfold: 'ri-arrow-down-s-line',
  file: 'ri-file-line',
  plus: 'ri-add-line',
  minus: 'ri-subtract-line',
}

const remix = {
  component: (props) => {
    const iconName = props.icon.replaceAll(/(^\w|-\w)/g, (match) => match.replaceAll('-', '').toUpperCase())

    return h(RemixIcons[iconName], {
      class: 'v-icon__svg',
      style: { fill: 'currentColor' },
    })
  },
}

export { aliases, remix }
